import 'babel-polyfill';
import 'core-js/features/url-search-params'
import 'core-js/es/promise/all-settled'

import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom'
import { configureStore } from '@reduxjs/toolkit';
import { thunk } from 'redux-thunk'
import promiseMiddleware from 'redux-promise-middleware';
import multi from 'redux-multi'

import { Provider } from 'react-redux';
import axios from 'axios';

import './stylesheets/main.scss';

import Routes from	'./router/routes';
import applicationReducer from './application_state';

//axios interceptor to all axios calls to prevent IE caching
axios.interceptors.request.use((config) => {
  var ts = +(new Date());
  var ret = config.url.replace(/(\?|&)_=.*?(&|$)/, "$1_=" + ts + "$2");
  config.url = ret + ((ret == config.url) ? (config.url.match(/\?/) ? "&" : "?") + "_=" + ts : "");
  return config;
});

const store = configureStore({
  reducer: applicationReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ['siteSurvey.carPictureCopKen.images', 'app.collectedData.siteSurvey.carPictureCopKen.images'],
        ignoredActions: ['UPDATE_COLLECTED_DATA'],
      },
    }).concat(thunk, promiseMiddleware, multi),
});

//console.logs app version to browser console.
console.log("app v." + __VERSION__);
const root = createRoot(document.getElementById('app'));

root.render(
  <Provider store={store}>
    <Router>
      {Routes(store)}
    </Router>
  </Provider>
);
